import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'

import { handleLogin } from 'internal-components/src/redux/modules/authentication'

import PageLoading from '../../components/Layout/PageLoading'

export class LoginView extends React.Component {
  componentDidMount() {
    /**
     * Not part of a saga because we cant watch for INIT_PATH,
     * and if you visit /login directly in this case, we will
     * never be able to react.
     *
     * This action creator just emits a HANDLE_LOGIN action that
     * sagas can react to.
     *
     * Additionally, the router context is not available in its
     * entirety and we do not have access to query string details
     * in redux state.
     */
    this.props.handleLogin(this.props.location)
  }

  render() {
    return (
      <div>
        <PageLoading />

        <div className="text-center m-b-md">
          <h3>Infinite Networks</h3>
          Logging in...
        </div>
      </div>
    )
  }
}

LoginView.propTypes = {
  handleLogin: Pt.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: Pt.object.isRequired,
}

export default connect(
  null,
  { handleLogin },
)(LoginView)



// WEBPACK FOOTER //
// ./src/views/Authentication/LoginView.jsx